<template>
    <div class="bg-color rounded-5 p-5">
        <div class="w-100 rounded-4">
            <div
                class="d-flex justify-content-between"
                style="background: rgb(241, 247, 255); border-radius: 27px 27px 0 0"
            >
                <h1 class="px-5 py-3 page-heading">Third Party Application History</h1>
                <button
                    class="text-button no-bg weight-600"
                    style="margin-right: 10px; background: transparent"
                    @click="openAddApplicationModal(null)"
                >
                    <span class="add-btn text-link margin-0">
                        <img src="@/assets/px/add.png" alt="" style="height: 20px; margin-right: 10px" />Add new
                        Application
                    </span>
                </button>
            </div>
            <div v-if="applicationList && applicationList.length > 0" class="rss-list-table profile-listing-body pb-2">
                <b-table
                    id="my-table"
                    :items="applicationList.slice().reverse()"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    bordered
                    responsive
                >
                    <template #cell(s_no)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(function_name)="row">
                        <span :id="`functionName-${row.index}`" class="column-ellipsis">
                            {{ row.item.function_name }}
                        </span>
                        <b-tooltip :target="`functionName-${row.index}`" triggers="hover" placement="bottom">
                            {{ row.item.function_name }}
                        </b-tooltip>
                    </template>
                    <template #cell(created_at)="row">
                        {{ formattedDate(row.item.created_at) }}
                    </template>
                    <template #cell(modified_at)="row">
                        {{ formattedDate(row.item.updated_at) }}
                    </template>
                    <template #cell(action)="row">
                        <div class="d-flex justify-content-center align-items-center" style="gap: 20px">
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Edit"
                                target="#target"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/edit-icon.png"
                                    alt=""
                                    style="height: 20px"
                                    id="target"
                                    @click="openAddApplicationModal(row.item.id)"
                                />
                            </ejs-tooltip>
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Delete"
                                target="#target"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/delete-icon.png"
                                    alt=""
                                    style="height: 20px"
                                    id="target"
                                    @click="showDeleteAlertPopUp(row.item.id)"
                                />
                            </ejs-tooltip>
                        </div>
                    </template>
                </b-table>
                <div class="b-table-pagination">
                    <div class="pagination-count-per-page">
                        <div class="pagination-number-per-page">
                            <div>
                                <span>Per page:</span>
                            </div>
                            <div>
                                <select style="" @change="changeCountPerPage" :value="perPage">
                                    <option v-for="item in perPageOptions" :key="item" :value="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <b-pagination
                        align="right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                    ></b-pagination>
                </div>
            </div>
            <div class="w-100 bg-white" v-else-if="applicationList && applicationList.length == 0">
                <div class="d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                    <h4>No items created</h4>
                </div>
            </div>
            <div class="w-100 bg-white" v-else>
                <div class="d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                    <h4>Fetching information...</h4>
                </div>
            </div>
            <div class="profile-delete-modal">
                <DeleteThirdPartyAppModal
                    v-if="showDeleteAlert"
                    :indexTodelete="applicationId"
                    @handleDelete="handleDelete"
                    @cancel="handleCancel"
                />
            </div>
            <AddThirdPartyAppModal
                v-if="showAddApplicationModal"
                :applicationId="applicationId"
                @cancel="handleCancel"
            />
        </div>
        <Loading v-if="loading" />
    </div>
</template>
<script>
    import Loading from '@/components/general/loading/loading.vue';
    import DeleteThirdPartyAppModal from './delete_third_party_app_modal.vue';
    import AddThirdPartyAppModal from './add_third_party_app_modal.vue';
    import { memberProfile } from '../../util/apiRequests';
    import { tryGetFilter } from '@/util/tryGetFilter';
    import { thirdPartyUpdateNotification } from '@/util/helpers/graphql/activityReminders.graphql.js';
    import dayjs from '@/util/dayjs';

    export default {
        name: 'ThirdPartyApplicationList',
        components: {
            AddThirdPartyAppModal,
            DeleteThirdPartyAppModal,
            Loading,
        },
        data() {
            return {
                applicationList: null,
                showDeleteAlert: false,
                applicationId: null,
                fields: [
                    { key: 's_no', label: 'S NO.', thStyle: { 'padding-left': '0 !important' }, class: 'table-col' },
                    { key: 'function_name', label: 'Name', class: 'table-col' },
                    { key: 'created_at', label: 'Created Date & Time', class: 'table-col' },
                    // { key: 'created_by', label: 'Created By', class: 'table-col' },
                    { key: 'modified_at', label: 'Modified Date & Time', class: 'table-col' },
                    // { key: 'updated_by', label: 'Modified By', class: 'table-col' },
                    { key: 'action', label: 'Action', class: 'action-sticky', stickyColumn: true, isRowHeader: true },
                ],

                // b-table properties
                storeKey: 'thirdPartyApplicationItems',
                perPageOptions: [5, 10, 20, 50, 100],
                currentPage: 1,
                perPage: 10,
                totalxRows: null,
                loading: true,
                companyName: null,
                showAddApplicationModal: false,
            };
        },
        computed: {
            rows() {
                return this.totalRows;
            },
        },
        methods: {
            formattedDate(date) {
                return date ? dayjs(date).format('MM/DD/YYYY hh:mmA') : '';
            },
            changeCountPerPage({ target: { value } }) {
                this.perPage = Number(value);
            },
            savedPagination() {
                const previousPagination = tryGetFilter(this.$store, this.storeKey);
                this.currentPage = previousPagination.currentPage ?? 1;
                this.perPage = previousPagination.perPage ?? 10;
            },
            showDeleteAlertPopUp(id) {
                this.showDeleteAlert = true;
                this.applicationId = id;
            },
            openAddApplicationModal(id) {
                this.applicationId = id;
                this.showAddApplicationModal = true;
            },
            async get_company() {
                let companyId = this.$store.state.user.company_id;
                const res = await this.$api.get(`/company/getCompany/${companyId}`);
                this.companyName = res.data.info[0].company_name;
            },
            async get3rdPartyApplicationsList() {
                try {
                    const endpoint = memberProfile.getFunction('3rdParty');
                    const fetchFunctionResponse = await this.$api.get(endpoint);
                    if (!fetchFunctionResponse) {
                        throw 'e';
                    }

                    let { data } = fetchFunctionResponse.data;
                    this.applicationList = data;
                    this.totalRows = data?.length;
                } catch (err) {
                    this.$toasted.error('Failed to fetch Applications list');
                } finally {
                    this.loading = false;
                }
            },
            async deleteApplication() {
                try {
                    const endpoint = memberProfile.deleteFunction(this.applicationId);
                    const deleteThirdPartyAppResponse = await this.$api.delete(endpoint);
                    if (!deleteThirdPartyAppResponse.data.success) {
                        throw deleteThirdPartyAppResponse.data.Message;
                    }

                    this.$toasted.success('Application deleted successfully !');
                } catch (err) {
                    this.$toasted.error('Failed to delete application');
                }
            },
            async send3rdPartyDeleteNotification() {
                try {
                    const endpoint = memberProfile.getListofUsers(this.applicationId);
                    const response = await this.$api.get(endpoint);
                    const emails = response?.data?.data;

                    await this.deleteApplication();

                    if (emails?.length) {
                        await thirdPartyUpdateNotification(emails);
                    }
                } catch (err) {
                    this.$toasted.error('Failed to send update notification!');
                }
            },
            async handleDelete() {
                try {
                    this.loading = true;
                    this.showDeleteAlert = false;
                    await this.send3rdPartyDeleteNotification();
                    await this.get3rdPartyApplicationsList();
                } catch (e) {
                    this.$toasted.error('Failed to delete item');
                }
            },
            async handleCancel() {
                this.applicationId = null;
                this.showDeleteAlert = false;
                this.showAddApplicationModal = false;
                await this.get3rdPartyApplicationsList();
            },
        },
        async created() {
            this.savedPagination();
            await this.get_company();
            await this.get3rdPartyApplicationsList();
            this.loading = false;
        },
        watch: {
            currentPage: function (val) {
                this.$store.commit('filters/updateFilter', {
                    stateKey: this.storeKey,
                    criteria: {
                        perPage: Number(this.perPage),
                        currentPage: Number(val),
                    },
                });
            },
            perPage: function (val) {
                this.$store.commit('filters/updateFilter', {
                    stateKey: this.storeKey,
                    criteria: {
                        currentPage: Number(this.currentPage),
                        perPage: Number(val),
                    },
                });
            },
        },
    };
</script>

<style scoped>
    .bg-color {
        background-color: rgba(255, 255, 255, 0.9);
    }
    .add-btn {
        background-color: #5057c3;
        color: white;
        padding: 10px;
        border-radius: 10px;
    }
</style>

<style>
    .rss-list-table table tbody tr > td:first-child {
        padding-left: 2.5em !important;
    }

    .b-table-sticky-column:last-child {
        right: 0;
        min-width: 100px;
    }

    .action-sticky {
        min-width: 150px;
        box-shadow: -10px 0px 10px 1px #aaaaaa;
    }

    .table-col {
        max-width: 150px;
        text-overflow: ellipsis;
        text-wrap: nowrap;
    }
</style>
